var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"macbook",staticClass:"macbook relative",style:(_vm.wrapperStyle)},[_c('div',{staticClass:"container absolute",style:(_vm.containerStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }